import store_parametre from "@/store/mods/clinique/parametres"

export default {
    name: 'recap-stock',
    components: {},
    props: {
        type_article_id: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            is_loading: false,
            out_stock_empty: false,
            upcoming_out_stock_empty: false,
            expired_stock_empty: false,
            upcoming_expired_stock_empty: false,

            nb_out_stock: 0,
            nb_upcoming_out_stock: 0,
            nb_expired_stock: 0,
            nb_upcoming_expired_stock: 0,
        }
    },

    computed: {

    },

    mounted() {
        this.getRecapStock()
    },

    methods: {
        getRecapStock() {
            this.is_loading = true
            const data = {
                type_article_id: this.type_article_id
            }
            store_parametre.getRecapStock(data).then((response) => {
                this.is_loading = false

                this.nb_out_stock = response.out_stock
                this.nb_upcoming_out_stock = response.upcoming_out_stock
                this.nb_expired_stock = response.expired_stock
                this.nb_upcoming_expired_stock = response.upcoming_expired_stock
            })
        },
    }
}